import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import ImageUpload from '../components/ImageUpload';
import '../components/ImageUpload.css';

const AddEvent = () => {
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const [formData, setFormData] = useState({
        title: '',
        description: '',
        cost: '',
        category: 'kids',
        eventUrl: '',
        imageUrl: '',
        date: '',
        endDate: '',
        isMultiDay: false
    });

    const categories = [
        { value: 'kids', label: 'Kids Event' },
        { value: 'adults', label: 'Adult Event' }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            const token = localStorage.getItem('token');
            const eventData = {
                ...formData,
                cost: parseFloat(formData.cost)
            };

            await axios.post(`${config.API_URL}/events`, eventData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setSuccess('Event added successfully!');

            // Reset form
            setFormData({
                title: '',
                description: '',
                cost: '',
                category: 'kids',
                eventUrl: '',
                imageUrl: '',
                date: '',
                endDate: '',
                isMultiDay: false
            });

            // Redirect to events after 2 seconds
            setTimeout(() => navigate('/events'), 2000);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to add event');
        }
    };

    return (
        <div className="container">
            <div className="form-container">
                <h1>Add New Event</h1>
                {error && <div className="error">{error}</div>}
                {success && <div className="success">{success}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Event Title</label>
                        <input
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="4"
                            required
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Cost (KSh)</label>
                            <input
                                type="number"
                                name="cost"
                                value={formData.cost}
                                onChange={handleChange}
                                step="0.01"
                                min="0"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Event Type</label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '8px' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', marginBottom: 0 }}>
                                    <input
                                        type="checkbox"
                                        checked={formData.isMultiDay}
                                        onChange={(e) => setFormData(prev => ({
                                            ...prev,
                                            isMultiDay: e.target.checked,
                                            endDate: e.target.checked ? prev.endDate : ''
                                        }))}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <span>Multi-day event</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>{formData.isMultiDay ? 'Start Date' : 'Event Date'}</label>
                            <input
                                type="date"
                                name="date"
                                value={formData.date}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {formData.isMultiDay && (
                            <div className="form-group">
                                <label>End Date</label>
                                <input
                                    type="date"
                                    name="endDate"
                                    value={formData.endDate}
                                    onChange={handleChange}
                                    min={formData.date}
                                    required
                                />
                            </div>
                        )}
                    </div>

                    <div className="form-group">
                        <label>Category</label>
                        <select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            required
                        >
                            {categories.map(cat => (
                                <option key={cat.value} value={cat.value}>
                                    {cat.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Event Registration URL</label>
                        <input
                            type="url"
                            name="eventUrl"
                            value={formData.eventUrl}
                            onChange={handleChange}
                            placeholder="https://example.com/register"
                            required
                        />
                    </div>

                    <ImageUpload
                        label="Event Image"
                        value={formData.imageUrl}
                        onChange={(url) => setFormData(prev => ({ ...prev, imageUrl: url }))}
                    />

                    <button type="submit" className="btn">Add Event</button>
                </form>
            </div>
        </div>
    );
};

export default AddEvent;
